// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/DocumentPageSetup.yaml
// Generated: 2026-07-08T13:37:28.405Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateDocumentPageSetup, UpdateDocumentPageSetup, DocumentPageSetup } from '@/types/core/DocumentPageSetup';

/**
 * DocumentPageSetup Service
 * CRUD operations for DocumentPageSetup via the ABP API.
 */
export const documentPageSetupService = new EntityService<DocumentPageSetup, CreateDocumentPageSetup, UpdateDocumentPageSetup>(
  '/api/core/documentpagesetup',
  'DocumentPageSetup',
);
